import { ServiceObject } from "app/models/serviceObject";
import { WorkTask } from "app/models/workTask";
import { Obstruction } from "./obstruction";

export class Work {

  public tasks: WorkTask[];
  public serviceObject: ServiceObject;
  public obstructions: Obstruction[];
  public fixedAddress: string;
  public address: string;
}




// WEBPACK FOOTER //
// /app/SPA/src/app/models/work.ts